var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { applyOpenGraphThumbnailSize, classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { EntityValue } from '../entities/entity-value';
import { Checkbox } from '../elements/checkbox';
var cls = classNames('entity-option-menu-item');
export var OptionMenuItemEntityValueCheckboxDefaultProps = {
  valueProps: {
    variant: 'card',
    showImageBorder: true
  },
  checkboxProps: {
    size: 20,
    borderRadius: 4,
    colors: {}
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n  "])), theme.UNIT(4))
});
var ValueStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: inherit;\n\n    .shp--cell-label,\n    .shp--cell-header {\n      color: inherit;\n    }\n  "], ["\n    color: inherit;\n\n    .shp--cell-label,\n    .shp--cell-header {\n      color: inherit;\n    }\n  "])))
});
var CheckboxStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-shrink: 0;\n  "], ["\n    flex-shrink: 0;\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'OptionMenuItemEntityValue',
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Value: styled(EntityValue)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  Checkbox: styled(Checkbox)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), CheckboxStyles)
};
export var OptionMenuItemEntityValueCheckbox = function (props) {
  var _a;
  var componentProps = useComponentProps(My.NAME, OptionMenuItemEntityValueCheckboxDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    item = componentProps.item,
    highlightText = componentProps.highlightText,
    isSelected = componentProps.isSelected,
    _b = componentProps.checkboxProps,
    checkboxProps = _b === void 0 ? {} : _b,
    _c = componentProps.valueProps,
    valueProps = _c === void 0 ? {} : _c;
  var entity = applyOpenGraphThumbnailSize('bubbleMedium')((_a = item === null || item === void 0 ? void 0 : item.data) === null || _a === void 0 ? void 0 : _a.entity);
  if (!entity) return null;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Checkbox, __assign({
    checked: isSelected
  }, checkboxProps)), React.createElement(My.Value, __assign({}, valueProps, {
    highlight: highlightText,
    entity: entity
  })));
};
OptionMenuItemEntityValueCheckbox.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;